/**
 * GeChiUI dependencies
 */
import { ColorPalette } from '@gechiui/components';

/**
 * Internal dependencies
 */
import withColorContext from './with-color-context';

export default withColorContext( ColorPalette );
